import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import { useMediaQuery } from "@mui/material";
import { requestDeletingOrganization } from "../../redux/actions/organizationProfileCreators";
import ControlDelete from "./ControlDelete";

export default function DeleteModal({
  open,
  handleClose,
  profile,
  page,
  searchText,
  status,
  handleModalClick,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const orgaUser = useSelector((state) => state.organizationProfile.orgaUser);
  const [openControl, setOpenControl] = useState(false);

  const handleCloseControl = () => {
    setOpenControl(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      orgaDelete: "",
    },
    validationSchema: Yup.object({
      orgaDelete: Yup.string()
        .required(t("required_field"))
        .test(
          "match-name-A",
          t("orgaDelete_must_match_name_A"),
          function (value) {
            return value === this.resolve(profile?.name_A);
          }
        ),
    }),
    onSubmit: (values, { resetForm }) => {
      if (orgaUser) {
        setOpenControl(true);
      } else {
        dispatch(
          requestDeletingOrganization(page, searchText, status, profile?.id)
        );
      }
      resetForm({ values: "" });
      handleClose();
    },
  });

  const isMobile = useMediaQuery("(max-width:1400px)");
  return (
    <div onClick={handleModalClick}>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        PaperProps={{
          sx: !isMobile
            ? { width: "30%", padding: "20px " }
            : { width: "90%", height: "80%", margin: "5px 0", padding: "5px " },
        }}
        disableBackdropClick
        disableEnforceFocus
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <IconButton onClick={handleClose}>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>

        <form onSubmit={formik.handleSubmit}>
          <DialogTitle mb={1} align="center">
            <Typography variant="title1" sx={{ fontSize: "38px" }}>
              {t("delete_organization")}
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ padding: "15px 10px" }}>
            <DialogContentText mb={2} align="center">
              {t("delete_orga_description")}
            </DialogContentText>
            <DialogContentText mb={1} align="center" id="delete-orga">
              {/* To confirm, type "
              <span style={{ fontWeight: 700 }}>{profile?.name_A}</span>" in the
              box below */}
              {t("type_delete_org")}
            </DialogContentText>
            <TextField
              error={Boolean(
                formik.touched.orgaDelete && formik.errors.orgaDelete
              )}
              fullWidth
              helperText={formik.touched.orgaDelete && formik.errors.orgaDelete}
              margin="normal"
              name="orgaDelete"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.orgaDelete}
              placeholder={t("type_orga_name")}
            />
          </DialogContent>
          <DialogActions>
            <Grid container>
              <Grid item xs={12} mb={2}>
                <Button
                  variant="contained"
                  color="error"
                  type="submit"
                  fullWidth
                  sx={{ height: "50px", borderRadius: "10px" }}
                >
                  {t("delete_organization")}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
      <ControlDelete
        profile={profile}
        user={orgaUser}
        open={openControl}
        handleClose={handleCloseControl}
        page={page}
        searchText={searchText}
        status={status}
      />
    </div>
  );
}
